export default function WhatsAppButton() {
  const handleWhatsAppClick = () => {
    window.open('https://wa.me/905551234567?text=Merhaba, Hediyatik hakkında bilgi almak istiyorum.', '_blank');
  };

  return (
    <button
      onClick={handleWhatsAppClick}
      className="fixed bottom-6 right-6 z-40 w-14 h-14 bg-green-500 hover:bg-green-600 text-white rounded-full shadow-lg flex items-center justify-center transition-all duration-300 hover:scale-110 group"
      aria-label="WhatsApp ile iletişime geç"
    >
      <i className="ri-whatsapp-line text-2xl"></i>
      <span className="absolute right-16 bg-gray-900 text-white text-sm px-3 py-2 rounded-lg opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap">
        Hemen Soru Sor
      </span>
    </button>
  );
}